<template>
  <v-dialog
    v-model="active"
    width="80%"
    persistent
  >
    <v-card color="primary">
      <v-card-title>
        <div class="text-h6">
          Evaluacion de investigación socioeconómica
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="evaluacionIse">
        <v-tabs
          v-model="tabs"
          color="secondary"
        >
          <v-tab key="0">
            Evaluación ISE
          </v-tab>
          <v-tab key="1">
            Informe de alcance
          </v-tab>
        </v-tabs>
        <v-tabs-items
          v-model="tabs"
          class="primary"
        >
          <v-tab-item key="0">
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    label="Evaluado"
                    :value="getFullName(evaluacionIse.Derivacion.Programacion.Expediente.Personal)"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Evaluador"
                    :value="evaluacionIse.CatEvaluador.evaluador"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Supervisor"
                    :value="evaluacionIse.CatSupervisor.evaluador"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Diagnóstico"
                    :value="evaluacionIse.CatDiagnostico.title"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-if="evaluacionIse.CatNumeral"
                    label="Numeral"
                    :value="evaluacionIse.CatNumeral.title"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  />
                  <v-text-field
                    v-else
                    label="Numeral"
                    value="No registrado"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    readonly
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="evaluacionIse.funciones"
                    label="Funciones"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    no-resize
                    rows="12"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="evaluacionIse.analisis"
                    label="Analisis"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    no-resize
                    rows="12"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="evaluacionIse.sintesisTecnica"
                    label="Síntesis técnica"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    no-resize
                    rows="12"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="evaluacionIse.observaciones"
                    label="Observaciones"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    no-resize
                    rows="12"
                  />
                </v-col>
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-btn
                    color="secondary"
                    :disabled="loading"
                    :loading="loading"
                    @click="triggerUpdateIse()"
                  >
                    Guardar cambios de evaluación
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item key="1">
            <v-container>
              <template v-if="evaluacionIse.InformeAlcance">
                <v-form
                  ref="form"
                  v-model="informeAlcanceForm"
                >
                  <v-row>
                    <v-col>
                      <v-text-field
                        label="Fecha de informe de alcance"
                        :value="evaluacionIse.InformeAlcance.fechaInformeAlcance"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        readonly
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Fecha de respuesta"
                        :value="evaluacionIse.InformeAlcance.fechaRespuesta"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        readonly
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="evaluacionIse.InformeAlcance.numeroOficio"
                        label="Número de oficio"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                      />
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="evaluacionIse.InformeAlcance.fk_idCatDiagnostico"
                        label="Diagnóstico"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        :items="diagnostico"
                        item-color="secondary"
                        item-text="title"
                        item-value="id"
                        readonly
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Respuesta"
                        :value="evaluacionIse.InformeAlcance.respuesta"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        readonly
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="evaluacionIse.InformeAlcance.informacionAdicional"
                        label="Información adicional"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        no-resize
                        rows="12"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </template>
              <template v-else>
                <v-form
                  ref="form"
                  v-model="informeAlcanceForm"
                >
                  <v-row>
                    <v-col>
                      <v-menu
                        v-model="menuFechaInforme"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            :value="computedFechaInformeAlcance"
                            label="Fecha de informe en alcance"
                            prepend-icon="mdi-calendar"
                            readonly
                            rounded
                            filled
                            dense
                            color="secondary"
                            background-color="primary"
                            v-bind="attrs"
                            :rules="required"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="informeAlcance.fechaInformeAlcance"
                          @input="menuFechaInforme = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col>
                      <v-menu
                        v-model="menuFechaRespuesta"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            :value="computedFechaRespuesta"
                            label="Fecha respuesta"
                            prepend-icon="mdi-calendar"
                            readonly
                            rounded
                            filled
                            dense
                            color="secondary"
                            background-color="primary"
                            v-bind="attrs"
                            :rules="required"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="informeAlcance.fechaRespuesta"
                          @input="menuFechaRespuesta = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="informeAlcance.numeroOficio"
                        label="Número de oficio"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                      />
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="informeAlcance.fk_idCatDiagnostico"
                        label="Diagnóstico"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        :items="diagnostico"
                        item-color="secondary"
                        item-text="title"
                        item-value="id"
                        :rules="required"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="informeAlcance.respuesta"
                        label="Respuesta"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        :rules="required"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="informeAlcance.informacionAdicional"
                        label="Información adicional"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                        no-resize
                        rows="12"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </template>
              <v-col
                cols="12"
                align="center"
              >
                <v-btn
                  color="secondary"
                  :disabled="!informeAlcanceForm || loading"
                  :loading="loading"
                  @click="triggerSaveInformeAlcance()"
                >
                  Guardar informe de alcance
                </v-btn>
              </v-col>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions class="justify-center" />
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    active: {
      type: Boolean,
    },

    evaluacionIse: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      menuFechaInforme: false,
      menuFechaRespuesta: false,
      loading: false,

      informeAlcance: {
        idExpediente: null,
        idEvaluacionIse: null,
        fechaInformeAlcance: null,
        numeroOficio: '',
        fk_idCatDiagnostico: null,
        fechaRespuesta: '',
        respuesta: '',
        fk_idCatEstatusInformeAlcance: null,
        informacionAdicional: '',
      },

      informeAlcanceForm: false,
      required: [(v) => !!v || 'Este campo es requerido.'],

      tabs: 0,
    };
  },

  computed: {
    ...mapGetters('diagnostico', {
      diagnostico: 'getDiagnostico',
    }),
    ...mapGetters('evaluadores', {
      evaluadores: 'getEvaluadores',
    }),
    ...mapGetters('numerales', {
      numerales: 'getNumerales',
    }),
    ...mapGetters('estatusEvaluacion', {
      estatusEvaluacion: 'getEstatusEvaluacion',
    }),

    computedFechaInformeAlcance() {
      return this.informeAlcance.fechaInformeAlcance ? moment(this.informeAlcance.fechaInformeAlcance).format('DD/MM/YYYY') : '';
    },

    computedFechaRespuesta() {
      return this.informeAlcance.fechaRespuesta ? moment(this.informeAlcance.fechaRespuesta).format('DD/MM/YYYY') : '';
    },
  },

  methods: {
    ...mapActions('evaluacionesISE', ['updateEvaluacionIse']),
    ...mapActions('informeAlcance', ['saveInformeAlcance', 'updateInformeAlcance']),

    closeDialog() {
      this.$emit('close');
      this.loading = false;
    },

    async triggerUpdateIse() {
      this.loading = true;
      await this.updateEvaluacionIse(this.evaluacionIse);

      this.closeDialog();
    },

    async triggerSaveInformeAlcance() {
      this.loading = true;
      if (!this.evaluacionIse.InformeAlcance) {
        await this.saveInformeAlcance({
          idExpediente: this.evaluacionIse.Derivacion.Programacion.fk_idExpediente,
          idEvaluacionIse: this.evaluacionIse.idIse,
          fechaInformeAlcance: moment(this.informeAlcance.fechaInformeAlcance).format('DD/MM/YYYY'),
          numeroOficio: this.informeAlcance.numeroOficio,
          fk_idCatDiagnostico: this.informeAlcance.fk_idCatDiagnostico,
          fechaRespuesta: moment(this.informeAlcance.fechaRespuesta).format('DD/MM/YYYY'),
          respuesta: this.informeAlcance.respuesta,
          fk_idCatEstatusInformeAlcance: this.informeAlcance.fk_idCatEstatusInformeAlcance,
          informacionAdicional: this.informeAlcance.informacionAdicional,
        });
      } else {
        await this.updateInformeAlcance({
          idInformeAlcance: this.evaluacionIse.InformeAlcance.idInformeAlcance,
          idExpediente: this.evaluacionIse.Derivacion.Programacion.fk_idExpediente,
          idEvaluacionIse: this.evaluacionIse.idIse,
          fechaInformeAlcance: this.evaluacionIse.InformeAlcance.fechaInformeAlcance,
          numeroOficio: this.evaluacionIse.InformeAlcance.numeroOficio,
          fk_idCatDiagnostico: this.evaluacionIse.InformeAlcance.fk_idCatDiagnostico,
          fechaRespuesta: this.evaluacionIse.InformeAlcance.fechaRespuesta,
          respuesta: this.evaluacionIse.InformeAlcance.respuesta,
          fk_idCatEstatusInformeAlcance:
            this.evaluacionIse.InformeAlcance.fk_idCatEstatusInformeAlcance,
          informacionAdicional: this.evaluacionIse.InformeAlcance.informacionAdicional,
        });
      }
      this.closeDialog();
    },
  },
};
</script>
